import MtaThankYouSubmitClaimContent from './MtaThankYouSubmitClaimContent';

export default MtaThankYouSubmitClaimContent;
